import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { observe } from 'mobx';
import { Provider } from 'mobx-react';
import registerServiceWorker from './services/sw';
import * as promiseFinally from 'promise.prototype.finally';
import { ApolloProvider } from 'react-apollo';
import { Rehydrated } from 'aws-appsync-react';

import clientGetter from './services/app-sync';
import { stores as routerStore } from './services/mobx-router';
import customStore from './stores';
import App from './App';

import './index.scss';
import 'jquery';
import 'bootstrap';
import 'semantic-ui-css/semantic.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-grid-layout/css/styles.css';
import 'react-sweet-progress/lib/style.css';

export const stores: any = {
    ...customStore,
    ...routerStore
};

//  All the Constant Elements
const mountableElement = document.getElementById('root') as HTMLElement;

promiseFinally.shim();
let jwtToken;
let apolloClient = null;
window.localStorage.removeItem('reduxPersist:appsync');
function renderToken(_jwtToken: any) {
    if (
        _jwtToken !== jwtToken
        || typeof jwtToken === 'undefined'
    ) {
        jwtToken = _jwtToken;
        (window as any)._____APP_STATE_____ = stores;
        if (jwtToken) {
            window.localStorage.removeItem('reduxPersist:appsync');
            apolloClient = clientGetter(jwtToken);
            customStore.apolloStore.setClient(apolloClient);
        }
        
        if (apolloClient) {
            stores.apolloStore.isProvided = true;
            // Need to re-render upon apollo client change *no caching
            ReactDOM.unmountComponentAtNode(mountableElement);
            setTimeout(
                () => {
                    ReactDOM.render(
                        (
                            <ApolloProvider client={apolloClient}>
                                <Rehydrated>
                                    <Provider {...stores}>
                                        <App />
                                    </Provider>
                                </Rehydrated>
                            </ApolloProvider>
                        ), 
                        mountableElement
                    );
                }, 
                10
            );
            return;
          } else {
            stores.apolloStore.isProvided = false;
            ReactDOM.render( 
                (
                    <Provider {...stores}>
                        <App />
                    </Provider>
                ), 
                mountableElement
            );
          }
    }  
}

observe(stores.authStore, (_change) => {
    let change = _change as any;
    if (change.name === 'jwtToken') {
        renderToken((change.newValue as any));
    }
    
});
renderToken(stores.authStore.jwtToken);

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.tsx